var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiRrArrowSmallRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-arrow-small-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 12.0001C17.9951 11.474 17.7832 10.971 17.41 10.6001L13.12 6.30007C12.9326 6.11382 12.6792 6.00928 12.415 6.00928C12.1508 6.00928 11.8974 6.11382 11.71 6.30007C11.6163 6.39303 11.5419 6.50363 11.4911 6.62549C11.4403 6.74735 11.4142 6.87806 11.4142 7.01007C11.4142 7.14208 11.4403 7.27279 11.4911 7.39465C11.5419 7.5165 11.6163 7.62711 11.71 7.72007L15 11.0001H5C4.73478 11.0001 4.48043 11.1054 4.29289 11.293C4.10536 11.4805 4 11.7348 4 12.0001C4 12.2653 4.10536 12.5196 4.29289 12.7072C4.48043 12.8947 4.73478 13.0001 5 13.0001H15L11.71 16.2901C11.5217 16.477 11.4154 16.7312 11.4144 16.9965C11.4135 17.2619 11.518 17.5168 11.705 17.7051C11.892 17.8934 12.1461 17.9997 12.4115 18.0006C12.6768 18.0016 12.9317 17.897 13.12 17.7101L17.41 13.4101C17.7856 13.0367 17.9978 12.5296 18 12.0001Z",
    fill: "#314155"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrArrowSmallRight);
export default __webpack_public_path__ + "static/media/fi-rr-arrow-small-right.2c57d648.svg";
export { ForwardRef as ReactComponent };